<template>
  <Layout>
    <div>
      <h1>Contact Us</h1>
      
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h3>Get in Touch</h3>
            </div>
            <div class="card-body">
              <form @submit.prevent="submitContact">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first_name">First Name *</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="first_name" 
                        v-model="contactForm.first_name"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last_name">Last Name *</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="last_name" 
                        v-model="contactForm.last_name"
                        required
                      >
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label for="email">Email *</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email" 
                    v-model="contactForm.email"
                    required
                  >
                </div>
                
                <div class="form-group">
                  <label for="organization">Organization</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="organization" 
                    v-model="contactForm.organization"
                  >
                </div>
                
                <div class="form-group">
                  <label for="subject">Subject *</label>
                  <select class="form-control" id="subject" v-model="contactForm.subject" required>
                    <option value="">Select Subject</option>
                    <option value="registration">Registration Issues</option>
                    <option value="abstract">Abstract Submission</option>
                    <option value="technical">Technical Support</option>
                    <option value="payment">Payment Issues</option>
                    <option value="general">General Inquiry</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label for="message">Message *</label>
                  <textarea 
                    class="form-control" 
                    id="message" 
                    rows="6"
                    v-model="contactForm.message"
                    placeholder="Please describe your inquiry in detail..."
                    required
                  ></textarea>
                </div>
                
                <div class="form-group">
                  <button type="submit" class="btn btn-primary btn-lg" :disabled="submitting">
                    {{ submitting ? 'Sending...' : 'Send Message' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h4>Contact Information</h4>
            </div>
            <div class="card-body">
              <div class="contact-info">
                <div class="contact-item">
                  <i class="fa fa-envelope fa-2x text-primary"></i>
                  <div>
                    <h5>Email</h5>
                    <p>isaci.contact@gmail.com</p>
                  </div>
                </div> 
              </div>
            </div>
          </div>
          
          <!-- <div class="card mt-3">
            <div class="card-header">
              <h4>Quick Links</h4>
            </div>
            <div class="card-body">
              <div class="list-group">
                <a href="#" class="list-group-item list-group-item-action">
                  <i class="fa fa-question-circle"></i> FAQ
                </a>
                <a href="#" class="list-group-item list-group-item-action">
                  <i class="fa fa-book"></i> Conference Guide
                </a>
                <a href="#" class="list-group-item list-group-item-action">
                  <i class="fa fa-map"></i> Venue Information
                </a>
                <a href="#" class="list-group-item list-group-item-action">
                  <i class="fa fa-calendar"></i> Important Dates
                </a>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import {apiService} from '@/config/api'

export default {
  name: 'Contact',
  components: {
    Layout
  },
  data() {
    return {
      contactForm: {
        first_name: '',
        last_name: '',
        email: '',
        organization: '',
        subject: '',
        message: ''
      },
      submitting: false
    }
  },
  methods: {
    async getContactInfo() {
      const response = await apiService.auth.getContactInfo({})
    },
    // 检验表单
    validateForm() {
      if (!this.contactForm.first_name || !this.contactForm.last_name || !this.contactForm.email || !this.contactForm.subject || !this.contactForm.message) {
        alert('Please fill in all required fields.')
        return false
      }
      return true
    },
    async submitContact() {
      if (!this.validateForm()) {
        return
      }
      this.submitting = true
      try {
        const response = await apiService.auth.getContactInfo(this.contactForm)
        if(response.data.code == 1){
          alert('Message sent successfully! We will reply to you as soon as possible.')
        }else{
          alert(response.data.msg)
        }
        
        // 重置表单
        this.contactForm = {
          first_name: '',
          last_name: '',
          email: '',
          organization: '',
          subject: '',
          message: ''
        }
      } catch (error) {
        console.error('Contact form submission failed:', error)
        alert('发送失败，请重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  /* background-color: #007bff;
   */
   background-color: #3498DB;
  color: white;
}

.form-group {
  margin-bottom: 1rem;
}

.btn-lg {
  padding: 12px 30px;
  font-size: 18px;
}

.contact-info {
  margin-top: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.contact-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.contact-item i {
  margin-right: 15px;
  margin-top: 5px;
}

.contact-item h5 {
  margin-bottom: 5px;
  color: #2c3e50;
  font-size: 16px;
}

.contact-item p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #eee;
  padding: 12px 15px;
}

.list-group-item:last-child {
  border-bottom: none;
}

.list-group-item i {
  margin-right: 10px;
  color: #007bff;
}
</style> 